import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const AppProviders = lazy(() => import('@app/components/AppProviders'))
const ParsedFileUploaderList = lazy(() => import('./ParsedFileUploaderList'))

// project_uploader.js sets `files` and `allowed-extensions`; the other attributes come from the twig template.
// The JSON attributes go down as raw strings so ParsedFileUploaderList can parse each only when it changes.
class FileUploaderListComponent extends ReactWebComponent {
  static get observedAttributes() {
    return ['files', 'languages', 'base-language-id', 'can-manage-languages', 'allowed-extensions']
  }

  override render() {
    return (
      <AppProviders>
        <ParsedFileUploaderList
          filesJson={this.prop('files')}
          languagesJson={this.prop('languages')}
          allowedExtensionsJson={this.prop('allowed-extensions')}
          baseLanguageId={Number(this.prop('base-language-id'))}
          canManageLanguages={this.prop('can-manage-languages') === 'true'}
        />
      </AppProviders>
    )
  }
}

customElements.define('file-uploader-list', FileUploaderListComponent)
